const coverageHomesQuery = `[{
    "coverageCode": "$coverageCodeHome",
    "customProperties": {
        "insuredAmountAudioVideo": $amountAudioVideo,
        "insuredAmountAntiques": $antique,
        "insuredAmountArt": $art
    },
    "deductibleAmount": $deductibleAmount,
    "insuredAmountCollections": $collection,
    "insuredAmountComputerEquipment": $computerEquipment,
    "insuredAmountJewelry": $jewelry,
    "insuredAmountMusicalInstruments": $instruments,
    "insuredAmountOther": 0,
    "insuredAmountTenantInterest": $tenantInterest,
    "insuredAmountValuablesOutdoors": $outsideCoverage,
    "insuredFamilyComposition": "$insuredFamilyComposition",
    "sumInsured": $homeSumInsured
}]`;

export default coverageHomesQuery;
